import React, { useContext, useEffect, useState } from "react";
import "./Manage_address_form.css";
import Heading_banner_section from "../../../common_components/heading_banner/Heading_banner_section";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRightFromBracket } from "@fortawesome/free-solid-svg-icons";
import { Form } from "react-bootstrap";
import Purple_Btn from "../../../common_components/common_btn/purple_btn/Purple_Btn";
import { faCircleInfo } from "@fortawesome/free-solid-svg-icons";

import Select from "react-select";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import { postAddress } from "../../../../utils/luxuryapis/orderProcess/orderProcess";
import {
  City,
  Country,
  Pincode,
  State,
} from "../../../../utils/apis/master/Master";
import { RegxExpression } from "../../../../utils/common";
import { Select2Data } from "../../../../utils/api";
import { Context } from "../../../../utils/context";
import LogoutModal from "../../../../components/Common-Component/Commonmodal/LogoutModal/LogoutModal";
function Manage_address_form() {
  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "YOUR ACCOUNT", link: "/luxury/account" },
    { label: "Manage Address", link: "/luxury/manage-address" },
    { label: "Add Address" },
  ];
  const { userdata, setSignin } = useContext(Context);

  const {
    control,
    register,
    handleSubmit,
    getValues,
    setError,
    clearErrors,
    formState: { errors },
    reset,
    trigger,
    setValue,
  } = useForm();

  const onSubmit = async (data) => {
    const formData = new FormData();

    formData.append("prefix", data?.prefix);
    formData.append("l_name", data?.l_name);
    formData.append("f_name", data?.f_name);
    formData.append("location", data?.location);
    formData.append("m_name", data?.m_name);
    formData.append("company", data?.company);
    formData.append("state_id", data?.state_id.value);
    formData.append("country_id", data?.country_id?.value);
    formData.append("city_id", data?.city_id.value);
    formData.append("address", data?.address);
    formData.append("pincode_id", data?.pincode_id?.value);
    formData.append("contact_no", data?.contact_no);
    formData.append("type", "Billing Information");

    const res = await postAddress(formData);
    if (res?.success) {
      navigate("/luxury/manage-address");
    } else {
    }
  };

  const [country, setCountry] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [pincode, setPincode] = useState([]);
  const GetAllCountries = async () => {
    const response = await Country();
    if (response?.success) {
      setCountry(await Select2Data(response?.data, "country_id"));
    }
  };
  const GetAllStates = async (id) => {
    const response = await State(id);
    if (response?.success) {
      setStates(await Select2Data(response?.data, "state_id"));
    }
  };

  const GetAllCities = async (id) => {
    const response = await City(id);
    if (response?.success) {
      setCities(await Select2Data(response?.data, "city_id"));
    }
  };
  const GetAllPincode = async (id) => {
    const response = await Pincode(id);
    if (response?.success) {
      setPincode(await Select2Data(response?.data, "pincode_id"));
    }
  };

  useEffect(() => {
    GetAllCountries();
  }, []);
  const [logoutshow, setLogoutshow] = useState(false);

  return (
    <>
      <section className="All_Orders Communication_preferences Manage_address Manage_address_form">
        <Heading_banner_section
          headingText={`${userdata?.first_name} ${userdata?.last_name}`}
          breadcrumbItems={breadcrumbItems}
        />

        <div className="custom_container">
          <div className="row justify-content-center">
            <div className="col-md-12">
              <div className="all_order_section_holder">
                <div className="text_holder">
                  <h3
                    className="sign_out_text"
                    onClick={() => setLogoutshow(true)}
                  >
                    <FontAwesomeIcon
                      className="me-3"
                      icon={faArrowRightFromBracket}
                    />
                    SIGN OUT
                  </h3>
                </div>

                <div className="heading_tab_content_holder">
                  <div className="heading_holder">
                    <h1>Add ADDRESS</h1>
                    {/* <p>
                      <Form.Check
                        type="checkbox"
                        label="is shipping address same as billing address"
                      />
                    </p> */}
                  </div>
                </div>
                <div className="row justify-content-center">
                  <div className="col-md-10">
                    <div className="content_box_holder">
                      <Form onSubmit={handleSubmit(onSubmit)}>
                        <div className="row">
                          <div className="col-md-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Prefix</Form.Label>
                              <Form.Select
                                className="form-control"
                                aria-label="Default select example"
                                placeholder="Select Prefix"
                                {...register("prefix", {
                                  required: "Prefix is required",
                                })}
                              >
                                <option value="">Select Prefix</option>
                                <option value="Ms">Ms</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Mr">Mr</option>
                              </Form.Select>

                              {errors.prefix && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.prefix.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-3">
                            <Form.Group className="mb-3">
                              <Form.Label>First Name*</Form.Label>
                              <Form.Control
                                type="text"
                                name="F_Name"
                                placeholder="Enter First Name"
                                {...register("f_name", {
                                  required: "First name required",
                                })}
                                onKeyDown={(event) => {
                                  if (!RegxExpression.name.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              {errors.f_name && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.f_name.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Middle Name*</Form.Label>
                              <Form.Control
                                type="text"
                                name="m_name"
                                placeholder="Enter Middle Name"
                                {...register("m_name", {
                                  // required: " Middle Name required",
                                })}
                                onKeyDown={(event) => {
                                  if (!RegxExpression.name.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              {/* <div className="error_text_holder">
                  <p>
                    <FontAwesomeIcon icon={faCircleInfo} className="me-2" />
                    Required Information
                  </p>
                </div> */}
                            </Form.Group>
                          </div>

                          <div className="col-md-3">
                            <Form.Group className="mb-3">
                              <Form.Label>Last Name*</Form.Label>
                              <Form.Control
                                type="text"
                                name="l_name"
                                placeholder="Enter Last Name"
                                {...register("l_name", {
                                  required: "Last Name required",
                                })}
                                onKeyDown={(event) => {
                                  if (!RegxExpression.name.test(event.key)) {
                                    event.preventDefault();
                                  }
                                }}
                              />
                              {errors.l_name && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.l_name.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Company Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="company"
                                placeholder="Enter Company Name"
                                {...register("company", {
                                  required: "company required",
                                })}
                              />
                              {errors.company && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.company.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Label>Address*</Form.Label>
                              <Form.Control
                                type="text"
                                name="address"
                                placeholder="Address"
                                {...register("address", {
                                  required: "address required",
                                })}
                              />
                              {errors.address && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.address.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3">
                              <Form.Label>Country*</Form.Label>
                              <Controller
                                name="country_id" // name of the field
                                {...register("country_id", {
                                  required: "Select Country",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors.country_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={country}
                                    onChange={(selectedOption) => {
                                      field.onChange(selectedOption); // Update Controller's value
                                      GetAllStates(selectedOption.value);
                                      setValue("country_id", selectedOption);
                                      setValue("state_id", null);
                                      setValue("city_id", null);
                                      setValue("pincode_id", null);
                                    }}
                                  />
                                )}
                              />

                              {errors.country_id && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.country_id.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>
                          <div className="col-md-4">
                            <Form.Group className="mb-3">
                              <Form.Label>State/Province*</Form.Label>
                              <Controller
                                name="state_id" // name of the field
                                {...register("state_id", {
                                  required: "Select State",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors.state_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={states}
                                    onChange={(selectedOption) => {
                                      field.onChange(selectedOption); // Update Controller's value
                                      GetAllCities(selectedOption.value);
                                      setValue("state_id", selectedOption);
                                      setValue("city_id", null);
                                      setValue("pincode_id", null);
                                    }}
                                  />
                                )}
                              />

                              {errors.state_id && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.state_id.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3">
                              <Form.Label>City*</Form.Label>
                              <Controller
                                name="city_id" // name of the field
                                {...register("city_id", {
                                  required: "Select City",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors.city_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={cities}
                                    onChange={(selectedOption) => {
                                      field.onChange(selectedOption); // Update Controller's value
                                      GetAllPincode(selectedOption.value);
                                      setValue("city_id", selectedOption);
                                      setValue("pincode_id", null);
                                    }}
                                  />
                                )}
                              />

                              {errors.city_id && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.city_id.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3">
                              <Form.Label>PinCode*</Form.Label>
                              <Controller
                                name="pincode_id" // name of the field
                                {...register("pincode_id", {
                                  required: "Select pincode",
                                })}
                                control={control}
                                render={({ field }) => (
                                  <Select
                                    styles={{
                                      control: (baseStyles) => ({
                                        ...baseStyles,
                                        borderColor: errors.pincode_id
                                          ? "red"
                                          : baseStyles,
                                      }),
                                    }}
                                    {...field}
                                    options={pincode}
                                  />
                                )}
                              />

                              {errors.pincode_id && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors.pincode_id.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          <div className="col-md-4">
                            <Form.Group className="mb-3">
                              <Form.Label>Contact No.*</Form.Label>

                              <Controller
                                name="contact_no"
                                control={control}
                                rules={{
                                  required: "Field is required",
                                }}
                                render={({ field }) => (
                                  <PhoneInput
                                    country={"in"}
                                    {...field}
                                    onChange={(value) => field.onChange(value)}
                                    placeholder="Enter Mobile Number"
                                  />
                                )}
                              />

                              {errors?.contact_no && (
                                <div className="error_text_holder">
                                  <p>
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="me-2"
                                    />
                                    {errors?.contact_no?.message}
                                  </p>
                                </div>
                              )}
                            </Form.Group>
                          </div>

                          {/* <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Check
                                type={"radio"}
                                name="1"
                                label={"Ship to this address"}
                              />
                            </Form.Group>
                          </div>

                          <div className="col-md-12">
                            <Form.Group className="mb-3">
                              <Form.Check
                                type={"radio"}
                                name="1"
                                label={"Ship to different address"}
                              />
                            </Form.Group>
                          </div> */}
                        </div>

                        <div className="btn_holder">
                          <div>
                            <Purple_Btn btnText="Save" type="submit" />
                          </div>
                        </div>
                      </Form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <LogoutModal
          show={logoutshow}
          onHide={() => setLogoutshow(false)}
          text="Are you sure you want to log out?"
          setSignin={setSignin}
        />
      </section>
    </>
  );
}

export default Manage_address_form;
